import React from 'react';

export default function EmptyValue() {
  return <em className="text-gray-400 italic">empty</em>;
}
